import axios from "axios";

export function getHomeSettings() {
    return axios.get('/api/settings/home');
}

export function updateHomeSettings(formData, jwt) {
    return axios.put('/api/admin/settings/home', formData, {
        headers: {
            'x-auth-token': jwt,
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function deleteHomeHeroBackground(jwt) {
    return axios.delete('/api/admin/settings/home/hero-background', {
        headers: {
            'x-auth-token': jwt
        }
    });
}
